import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import * as walletServices from '../walletServices'
import { DeleteCryptoAddressWithdrawPayload } from '../walletTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'
import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useDeleteWithdrawCryptoAddress = (
  options?: IOptionsUseMutation<void>,
) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<void, ErrorDetail, DeleteCryptoAddressWithdrawPayload>({
    mutationFn: walletServices.deleteWithdrawCryptoAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WITHDRAW_CRYPTO_ADDRESSES],
      })

      if (options?.onSuccess) {
        options.onSuccess()
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)

      let errorMessage = 'api:errors.somethingWrong'

      if (options?.onError)
        options?.onError({ ...err, errorMessage: t(errorMessage), code })
    },
  })
}
